// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2VVem","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Tpssu"};